
import BlogImagesPreview from "../../ImagesPreview/BlogImagesPreview";

const ImageBlock = ({
  onRemove,
  blockImage,
  onOpenBannerImageBlockSelector,
  onRemoveBlockImage
}) => {
 
  return (
    <div className="block-container">
      <div className="block-header">
        <h4 className="block-title">Image Block</h4>
        <div className="block-actions">
          <button className="block-action-btn remove" onClick={onRemove}>
            <span className="mdi mdi-delete"></span> Remove
          </button>
        </div>
      </div>
      <div className="card-body">
        <div className="col-lg-7">
          <BlogImagesPreview
            acceptMultipleFiles={false}
            featuredImage={true}
            savedImages={blockImage && blockImage.blog_image_id ? [blockImage] : []}
            userProfile={false}
            style={{ width: "85%" }}
            onOpen={onOpenBannerImageBlockSelector}
            deleteDisable={true}
            selectedImageInfo={blockImage}
            onRemoveImageIds={onRemoveBlockImage}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageBlock;
